<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="supplier && supplier.id">{{ 'SUPPLIERS.SUPPLIERS_FORM.EDIT' | translate }}</span>
    <span *ngIf="!supplier || !supplier.id">{{ 'SUPPLIERS.SUPPLIERS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="suppliers-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="name" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.TYPE' | translate }}</label>
          <app-type-select
            [parentFormGroup]="form"
            [groupType]="'supplier'"
            [passFormControlName]="'type_id'"
            [bindValue]="'id'"
          ></app-type-select>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.NOTE' | translate }}</label>
          <textarea
            class="form-control note-textarea"
            formControlName="note"
            [rows]="1"
            [cols]="30"
            pInputTextarea
            autoResize="true"
          ></textarea>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.ADDRESS' | translate }}</label>
          <input type="text" class="form-control" formControlName="address" />
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.REGISTRATION_NUMBER' | translate }}</label>
          <input type="text" class="form-control" formControlName="registration_number" />
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.VAT_NUMBER' | translate }}</label>
          <input type="text" class="form-control" formControlName="vat_number" />
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'SUPPLIERS.SUPPLIERS_FORM.RESPONSIBLE_PERSON' | translate }}</label>
          <input type="text" class="form-control" formControlName="responsible_person" />
        </div>
      </div>

      <div class="col-sm-12">
        <div class="form-group mt-3">
          <div class="modal-section-title mb-1">{{ 'SUPPLIERS.SUPPLIERS_FORM.BANK_ACCOUNTS' | translate }}</div>
          <app-bank-data [parentFormGroup]="form" [extended]="true"></app-bank-data>
        </div>
      </div>

      <div class="col-sm-12">
        <app-contact [parentFormGroup]="form" [showNote]="true"></app-contact>
      </div>

      <hr class="w-100 mt-0 mb-1 mt-3" />

      <h3 class="modal-section-title col-sm-12">{{ 'SUPPLIERS.SUPPLIERS_FORM.SELECT_COMPANY' | translate }}</h3>

      <div
        *ngFor="let company of form.get('companies')?.controls; let i = index"
        formArrayName="companies"
        class="col-sm-3"
      >
        <div [formGroupName]="i">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              [attr.id]="'company' + '-' + company.get('id').value"
              [formControl]="company.get('selected')"
            />
            <label class="custom-control-label" [attr.for]="'company' + '-' + company.get('id').value">
              {{ company.get('shortName').value }}
            </label>
          </div>
        </div>
      </div>

      <hr class="w-100 mt-1 mb-1" />
      <div
        *ngFor="let company of form.get('companies')?.controls; let j = index"
        formArrayName="companies"
        class="col-sm-12"
      >
        <div [formGroupName]="j" *ngIf="company.get('selected').value">
          <app-contact-person
            [parentFormGroup]="company"
            [showName]="true"
            [showNameFrom]="'shortName'"
          ></app-contact-person>

          <app-property
            [parentFormGroup]="company"
            [title]="'SUPPLIERS.SUPPLIERS_FORM.PROPERTIES_TITLE' | translate"
          ></app-property>

          <hr class="company-hr" />
        </div>
      </div>

      <div class="w-100"></div>

      <div class="col-sm-12 mt-3">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="active" formControlName="active" />
          <label class="custom-control-label" for="active">
            {{ 'SUPPLIERS.SUPPLIERS_FORM.ACTIVE' | translate }}
          </label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="suppliers-form" [disabled]="form.invalid">
    {{ 'SUPPLIERS.SUPPLIERS_FORM.SAVE' | translate }}
  </button>
</div>
